import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { MICROSERVICES } from '@shared/constants/microservices';
import { Observable } from 'rxjs/internal/Observable';
import { MroManualRepository } from './mro-manual.repository';
import { GetVehicleMROsPaginatedResponse, ReportingPeriodResponse, VehicleMROResponse } from '../domain/mro-manual-model';

@Injectable()
export class MroManualApiService implements MroManualRepository {
    private _http = inject(HttpClient);
    private baseUrl = `${environment.url}${MICROSERVICES.mro_manual}`;

    createVehicleMRO(id: string, miles: number, odometerPhoto: File): Observable<VehicleMROResponse> {
        const formData = new FormData();
        formData.append('miles', miles.toString());
        formData.append('odometerPhoto', odometerPhoto);

        return this._http.post<VehicleMROResponse>(`${this.baseUrl}/vehicles/${id}`, formData);
    }

    deleteVehicleMRO(id: string, miles: number, odometerPhoto: File, feedback: string): Observable<void> {
        const formData = new FormData();
        if(miles !== 0) {
            formData.append('miles', miles.toString());
            formData.append('odometerPhoto', odometerPhoto);
            formData.append('feedback', feedback);
        }
 
        return this._http.request<void>('delete', `${this.baseUrl}/vehicles/${id}`, {
            body: formData
        });
    }

    getCurrentReportingPeriod(): Observable<ReportingPeriodResponse> {
        return this._http.get<ReportingPeriodResponse>(`${this.baseUrl}/reporting-periods/current`)
    }

    getVehicleMROById(id: string): Observable<VehicleMROResponse> {
        return this._http.get<VehicleMROResponse>(`${this.baseUrl}/vehicles/${id}`);
    }

    getVehicleMROsByUserId(page = 1, size = 10): Observable<GetVehicleMROsPaginatedResponse> {
        const params = new HttpParams()
            .set('page', page.toString())
            .set('size', size.toString());

        return this._http.get<GetVehicleMROsPaginatedResponse>(`${this.baseUrl}/vehicles`, { params });
    }

    recordOdometerReading(id: string, miles: number, odometerPhoto: File): Observable<void> {
        const formData = new FormData();
        formData.append('miles', miles.toString());
        formData.append('odometerPhoto', odometerPhoto);

        return this._http.post<void>(`${this.baseUrl}/vehicles/${id}/miles-readings`, formData);
    }

}
